/** Correlation id for HTTP, errors, and traces. */

const NO_CRYPTO = 'Web Crypto API (randomUUID or getRandomValues) is required for correlation IDs';

/** Generates a UUID v4 string using the Web Crypto API. */
function uuidV4Fallback(c: Crypto): string {
  const b = new Uint8Array(16);
  c.getRandomValues(b);
  b[6] = (b[6] & 0x0f) | 0x40;
  b[8] = (b[8] & 0x3f) | 0x80;
  const h = [...b].map((x) => x.toString(16).padStart(2, '0')).join('');
  return `${h.slice(0, 8)}-${h.slice(8, 12)}-${h.slice(12, 16)}-${h.slice(16, 20)}-${h.slice(20)}`;
}

/** Creates a unique correlation ID using the Web Crypto API. */
export function createCorrelationId(): string {
  const c = globalThis.crypto;
  if (!c) throw new Error(NO_CRYPTO);
  if (typeof c.randomUUID === 'function') return c.randomUUID();
  if (typeof c.getRandomValues === 'function') return uuidV4Fallback(c);
  throw new Error(NO_CRYPTO);
}
